import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { ModernHeader } from './ModernHeader'
import { BottomNav } from './BottomNav'
import { NotificationProvider } from '../../contexts/NotificationContext'

export const Layout: React.FC = () => {
 const [sidebarOpen, setSidebarOpen] = useState(false)

 return (
 <NotificationProvider>
  <div className="min-h-screen bg-background flex flex-col">

  {/* ── Top header (full nav on desktop, hamburger on mobile) ── */}
  <ModernHeader onMenuOpen={() => setSidebarOpen(true)} />

  {/* ── Mobile slide-out sidebar ── */}
  <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(false)} />

  {/* ── Page content ── */}
  <main className="flex-1 px-4 py-5 sm:px-6 lg:px-8 lg:py-7 pb-24 lg:pb-8 overflow-auto">
  <Outlet />
  </main>

  {/* ── Bottom navigation — mobile only ── */}
  <BottomNav onMenuOpen={() => setSidebarOpen(true)} />
  </div>
 </NotificationProvider>
 )
}
